import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn("Sentry DSN not configured. Error tracking disabled.");
    return;
  }

  Sentry.init({
    dsn,
    integrations: [new BrowserTracing()],

    // Performance data tracking (0.1 = 10% sampling for cost optimization)
    // Changed from 1.0 (100%) to reduce Sentry quota usage while maintaining adequate monitoring
    tracesSampleRate: 0.1,
  });
}
